import { APP_ROUTE } from 'app/app-routing.constant';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ClassInfo } from 'app/teacher/models/class-info';
import { collapseAnimation } from 'app/core/app-constants/angular-animations';
import { Component } from '@angular/core';
import { first, tap } from 'rxjs/operators';
import { LogicalErrorDocument } from 'app/shared/models/logical-error-document';
import { LogicalErrorDocumentType } from 'app/shared/constants/logical-error-document-type';
import { MinistryFeedbackModalComponent } from 'app/teacher/modals/ministry-feedback-modal/ministry-feedback-modal.component';
import { MinistryFeedbackService } from 'app/core/ministry-feedback/ministry-feedback.service';
import { MinistrySurveyModel } from 'app/core/ministry-feedback/ministry.model';
import { ModalService } from 'app/core/modals/services/modal.service';
import { RemediationLogicalErrorModel } from 'app/shared/models/remediation-logical-error.model';
import { TeacherService } from 'app/teacher/services/teacher.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from 'ngx-auth';
import { AuthenticationService, UserRole } from 'app/core/authentication';
import { SCHOOL_ADMIN_ROUTE } from 'app/school-admin/school-admin-routing.constant';

@UntilDestroy()
@Component({
    animations: [collapseAnimation],
    selector: 'kh-remediation-modal',
    styleUrls: ['./remediation-modal.component.less'],
    templateUrl: './remediation-modal.component.html',
    standalone: false
})
export class RemediationModalComponent {
  public classInfo = this.teacherService.activeClassInfo as ClassInfo;
  public logicalError!: RemediationLogicalErrorModel;
  public showLearnMore = false;
  public survey!: MinistrySurveyModel;
  public show = false;
  public closed = false;
  public documentType = LogicalErrorDocumentType;
  public skipSurvey = false;
  public forcePremium = false;

  public constructor(
    private readonly teacherService: TeacherService,
    private readonly feedbackService: MinistryFeedbackService,
    private readonly modalService: ModalService,
    private readonly bsModalRef: BsModalRef,
    private readonly authService: AuthenticationService) {
  }

  public ngOnInit(): void {
    this.closed = false;
    if (!this.skipSurvey) {
      this.feedbackService.getTeacherSurvey().pipe(
        tap(survey => {
          this.survey = survey;
        }),
        untilDestroyed(this)
      )
        .subscribe();
    }
    this.show = this.logicalError?.IsRemediationDocumentAvailable || this.classInfo?.IsPremium || this.forcePremium;
  }

  public closeModal(): void {
    this.bsModalRef.hide();
  }

  public getRemediationDocumentRoute(document: LogicalErrorDocument): string[] {
    return APP_ROUTE.TEACHING_SUPPORTS.REMEDIATION.DOCUMENT.route(
      this.logicalError.LogicalErrorId, document.DocumentType);
  }
}
